/**
 * 세금 (공통/돈계산 1-1, 3-1, 2026-11-04 새 기준)
 *
 * - 세금 기준은 단가 전액(그날 노무비, day.ts taxable)이다.
 * - 일반 소득세(일용): (일당 - 150,000원) x 6% x (1 - 55%) = 넘는 금액의 2.7%, 10원 미만 버림. 지방소득세는 소득세의 10%, 10원 미만 버림.
 * - 3.3%: 일당 x 3%, 10원 미만 버림. 지방소득세는 그 10%(0.3%).
 * - 1,000원 미만이면 안 뗀다. 지급 한 건 단위로 본다: 여러 날치를 한 번에 주면 날짜별 세금을 더해 판단(국세청 해석).
 * - 원천징수 방식은 사무소가 세금을 떼는 경우 오늘 정산에서 인력마다 고른다(기본 일반 소득세, 2026-11-04 대표님).
 * 세무사(아버님) 검토 대기: 조사/소장님질문 "세무사 계산 검토 8개" 1~5번.
 */
import { big, bp, floor10, floorDiv, num, ONE } from './arith.ts';
import type { Standards } from './standards.ts';

export type TaxMethod = '일반 소득세' | '3.3%';

/** 하루치 소득세(10원 미만 버림, 1,000원 미만 판단 전) */
export function dayIncomeTax(taxable: number, method: TaxMethod, std: Standards): bigint {
  const t = big(taxable);
  if (method === '3.3%') return floor10(floorDiv(t * bp(std.biz_tax_pct), ONE));
  const over = t - big(std.tax_deduct);
  if (over <= 0n) return 0n;
  return floor10(floorDiv(over * bp(std.tax_pct) * (ONE - bp(std.tax_credit_pct)), ONE * ONE));
}

/** 지급 한 건의 세금. taxables는 이번에 함께 주는 날들의 세금 기준(날짜마다 하나). */
export function payoutTax(taxables: number[], method: TaxMethod, std: Standards): { income_tax: number; local_tax: number } {
  let income = 0n;
  for (const t of taxables) income += dayIncomeTax(t, method, std);
  if (income < big(std.tax_min)) return { income_tax: 0, local_tax: 0 };
  const local = floor10(floorDiv(income * bp(std.local_tax_pct), ONE));
  return { income_tax: num(income), local_tax: num(local) };
}
